import React from "react";

import { graphql } from "gatsby";

import LatestNewsCards from "./news/latestNewsCards";
import CardSlider from "../components/cardSlider/cardSlider";

interface KontentItemLatestNewsSliderSectionProps {
  data: Queries.kontent_item_latest_news_slider_section;
}

const KontentItemLatestNewsSliderSection: React.FC<KontentItemLatestNewsSliderSectionProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  return (
    <CardSlider
      header={elements.title?.value || ""}
      description={elements.description?.value || ""}
      moreUrl={
        (elements.button_url?.value?.length ?? 0) > 0
          ? elements.button_url?.value?.[0]?.id
          : undefined
      }
    >
      {LatestNewsCards({
        newsCategories: elements.news_category?.value as Queries.kontent_item_taxonomy_element[],
        pressCategories: elements.press_category?.value as Queries.kontent_item_taxonomy_element[],
      })}
    </CardSlider>
  );
};

export const query = graphql`
  fragment KontentItemLatestNewsSliderSection on kontent_item_latest_news_slider_section {
    id
    system {
      codename
    }
    elements {
      title {
        value
      }
      description {
        value
      }
      button_url {
        value {
          id
        }
      }
      press_category {
        value {
          codename
        }
      }
      news_category {
        value {
          codename
        }
      }
    }
  } 
`;

export default KontentItemLatestNewsSliderSection;
